import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Integrations" hint="Google Places key (only current external dep) — extend as more arrive." /> }
